module.exports = __webpack_public_path__ + "2d11b77ac56d614e4c68d4f38d082337.png";